<template>
    <div v-if="selectedTab === name" class="pt-4">
        <slot></slot>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'TabContent',
    props: {
        name: {
            type: String,
            required: true,
        },
        selectedTab: {
            type: String,
            required: true,
        },
    },
});
</script>
